import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { Home, Gamepad2, Zap, AlertCircle } from 'lucide-react'
import Button from '../components/ui/Button'
import Card, { CardHeader, CardContent, CardFooter } from '../components/ui/Card'

export default function NotFoundPage() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-2xl w-full"
      >
        <Card shadow="lg" padding="lg">
          <CardHeader className="text-center">
            <div className="flex justify-center mb-6">
              <div className="p-4 rounded-full bg-danger/10">
                <AlertCircle className="w-16 h-16 text-danger" />
              </div>
            </div>
            <h1 className="text-4xl font-bold mb-4">404 - Page Not Found</h1>
            <p className="text-text-muted text-lg">
              Oops! The page you're looking for doesn't exist or has been moved.
            </p>
          </CardHeader>
          
          <CardContent>
            <div className="mb-8">
              <h2 className="text-xl font-semibold mb-4">Available Pages</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <Button
                  as={Link}
                  to="/"
                  variant="ghost"
                  className="justify-start h-auto py-4"
                >
                  <div className="flex items-center gap-4">
                    <div className="p-2 rounded-lg bg-primary/10">
                      <Home className="w-6 h-6 text-primary" />
                    </div>
                    <div className="text-left">
                      <div className="font-semibold">Home</div>
                      <div className="text-sm text-text-muted">Game selection and stats</div>
                    </div>
                  </div>
                </Button>
                
                <Button
                  as={Link}
                  to="/tic-tac-toe"
                  variant="ghost"
                  className="justify-start h-auto py-4"
                >
                  <div className="flex items-center gap-4">
                    <div className="p-2 rounded-lg bg-primary/10">
                      <Gamepad2 className="w-6 h-6 text-primary" />
                    </div>
                    <div className="text-left">
                      <div className="font-semibold">Tic Tac Toe</div>
                      <div className="text-sm text-text-muted">Classic 3x3 grid game</div>
                    </div>
                  </div>
                </Button>
                
                <Button
                  as={Link}
                  to="/2048"
                  variant="ghost"
                  className="justify-start h-auto py-4"
                >
                  <div className="flex items-center gap-4">
                    <div className="p-2 rounded-lg bg-secondary/10">
                      <Zap className="w-6 h-6 text-secondary" />
                    </div>
                    <div className="text-left">
                      <div className="font-semibold">2048</div>
                      <div className="text-sm text-text-muted">Slide and combine tiles</div>
                    </div>
                  </div>
                </Button>
              </div>
            </div>
            
            <div className="bg-surface-variant rounded-xl p-6 mb-6">
              <h3 className="font-semibold mb-2">What could have happened?</h3>
              <ul className="space-y-2 text-text-muted">
                <li className="flex items-start gap-2">
                  <span className="text-primary">•</span>
                  <span>The page may have been moved or deleted</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-primary">•</span>
                  <span>You might have typed the URL incorrectly</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-primary">•</span>
                  <span>The link you followed might be outdated</span>
                </li>
              </ul>
            </div>
          </CardContent>
          
          <CardFooter className="border-t border-border pt-6">
            <div className="flex flex-col sm:flex-row gap-4 w-full">
              <Button
                as={Link}
                to="/"
                variant="primary"
                size="lg"
                className="flex-1"
              >
                <Home className="w-5 h-5 mr-2" />
                Go to Homepage
              </Button>
              
              <Button
                onClick={() => window.history.back()}
                variant="secondary"
                size="lg"
                className="flex-1"
              >
                Go Back
              </Button>
            </div>
          </CardFooter>
        </Card>
      </motion.div>
    </div>
  )
}